import clsx from 'clsx';
import Link from '@/components/Link';
import Image from '@/components/Image';
import useHover from '@/hooks/useHover';

export default function Partner({ uri, title, featuredImage, excerpt }) {
  return (
    <Link
      href={uri}
      className="relative w-full transition duration-300 ease-in-out bg-white rounded-lg ring-1 ring-black ring-opacity-10 hover:ring-opacity-20 lg:rounded-xl xl:rounded-2xl"
    >
      {({ isHovering }) => (
        <>
          <div className="relative z-20 flex items-start w-full px-6 py-6 space-x-6 bg-white rounded-lg lg:rounded-xl lg:py-8 xl:rounded-2xl">
            <div>
              <Image
                className={clsx(
                  'h-16 w-16 transform rounded-full shadow transition duration-300 ease-in-out',
                  isHovering === false && 'scale-100',
                  isHovering === true && 'scale-75'
                )}
                alt={title}
                src={featuredImage.node.sourceUrl}
                srcSet={featuredImage.node.srcSet}
              />
            </div>
            <div className="flex flex-col flex-1 space-y-2">
              <h3 className="text-lg font-medium lg:text-xl lg:font-semibold">
                {title}
              </h3>
              {excerpt !== null && (
                <div
                  className="text-base leading-7 text-gray-500 lg:text-lg"
                  dangerouslySetInnerHTML={{ __html: excerpt }}
                />
              )}
            </div>
          </div>
          <div
            className={clsx(
              'absolute inset-0 z-0 transform rounded-lg shadow-outside transition duration-300 ease-in-out lg:rounded-xl xl:rounded-2xl',
              isHovering === false && 'scale-90 opacity-0',
              isHovering === true && 'scale-100 opacity-100'
            )}
          />
        </>
      )}
    </Link>
  );
}
